// Import Swiper and required modules
import Swiper from "swiper";
import { Navigation } from 'swiper/modules';

window.addEventListener("DOMContentLoaded", () => {

  const recommendationSections = document.querySelectorAll('.upsell__recommendations');

  if (recommendationSections.length === 0) {
    return;
  }

  recommendationSections.forEach(section => {
    const swiperElement = section.querySelector('.js-recommendations-swiper');

    if (swiperElement) {
      let recommendationsSwiper = new Swiper(swiperElement, {
        init: false,
        modules: [Navigation],
        spaceBetween: 8,
        slidesPerView: 1.9,
        watchOverflow: true,
        navigation: {
          nextEl: '.upsell__recommendation-control--next',
          prevEl: '.upsell__recommendation-control--prev',
        },
        breakpoints: {
          480: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 2.5,
          },
          1024: {
            slidesPerView: 3.5,
          }
        }
      });

      recommendationsSwiper.init();
    }
  });
});

function addToCartAjax(button, quantity = 1) {
  if (!button) {
    console.error('Button element is required');
    return Promise.reject(new Error('Button element is required'));
  }

  const textElement = button.querySelector('[data-add-to-cart-text]');
  
  button.classList.add('btn--loading');
  if (textElement) {
    textElement.textContent = 'Adding...';
  }
  
  let variantId = button.dataset.variantId;
  
  if (!variantId) {
    const form = button.closest('form');
    if (form) {
      const variantSelect = form.querySelector('select[name="id"], input[name="id"][type="hidden"], [data-product-select]');
      if (variantSelect) {
        variantId = variantSelect.value;
      }
    }
  }
  
  if (!variantId) {
    console.error('No variant ID found');
    
    button.classList.remove('btn--loading');
    if (textElement) {
      const defaultText = textElement.dataset.defaultText || 'Add to cart';
      textElement.textContent = defaultText;
    }
    
    return Promise.reject(new Error('No variant ID found'));
  }
  
  if (button.dataset.quantity && !quantity) {
    quantity = parseInt(button.dataset.quantity, 10);
  }
  
  const data = {
    id: variantId,
    quantity: quantity
  };
  
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
  .then(response => response.json())
  .then(product => {
    button.classList.remove('btn--loading');
    if (textElement) {
      const defaultText = textElement.dataset.defaultText || 'Add to cart';
      textElement.textContent = defaultText;
    }
    
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      detail: {
        product: product,
        addToCartBtn: button
      }
    }));

    return product;
  })
  .catch(error => {
    button.classList.remove('btn--loading');
    if (textElement) {
      const defaultText = textElement.dataset.defaultText || 'Add to cart';
      textElement.textContent = defaultText;
    }
    
    console.error('Error adding to cart:', error);
    
    document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
      detail: {
        errorMessage: error.description || 'Error adding to cart'
      }
    }));
    
    throw error;
  });
}



function setupAddToCartButtons() {
  document.addEventListener('click', function(event) {


    const addToCartBtn = event.target.closest('[data-add-to-cart]');
    if (!addToCartBtn) return;
    
    event.preventDefault();
    
    addToCartAjax(addToCartBtn);
  });
}

document.addEventListener('DOMContentLoaded', setupAddToCartButtons);
